import { getResurrectedUser } from 'helpers/localstorage';
import { setItem, getItem } from 'helpers/localstorage';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useState } from 'react';

export const isEmailQualityWarningClosed = () => {
  return getItem('emailQualityWarningClosed') === 'true';
};

export const isResurrectedUser = () => {
  return getResurrectedUser() === 'true';
};

export const isBadQualityEmail = userInfo => {
  return (
    userInfo && (!userInfo.isEmailDeliverable || userInfo.isCloudMarkDomain)
  );
};

export const useEmailQualityWarning = props => {
  const { userInfo, eventHandler } = props;
  const [isClosed, setIsClosed] = useState(isEmailQualityWarningClosed());
  const showAlert =
    isResurrectedUser() && !isClosed && isBadQualityEmail(userInfo);

  const setWarningClosed = () => {
    setItem('emailQualityWarningClosed', 'true');
  };

  const onClickUpdateAddress = () => {
    eventHandler(CLICK, {
      'Click Type': 'Update Email Resurrected',
    });
  };

  const onClickClose = () => {
    setWarningClosed();
    setIsClosed(true);
  };

  return {
    showAlert,
    onClickUpdateAddress,
    onClickClose,
  };
};
